$(document).ready(function() {

    $("body").on("click", ".quickIconsHolder .showSearch, #mobileBottomTrigger .showSearch", function(e) {
        e.preventDefault();
        $('.quickIconsHolder').addClass('showSearch');
        $('.globalSearch').addClass('show');
        $('#newWAheader').addClass('noShadow');

        if ($(window).width() >= 992) {
            $('#ttgRbContentWrapper .globalSearch input.ttgSearchField').focus();
        } else {
            $('.naviHolder .globalSearch input.ttgSearchField').focus();
        }
    });

    $("body").on("click", ".globalSearch .closeSearch", function(e) {
        e.preventDefault();
        $('.quickIconsHolder').removeClass('showSearch');
        $('.globalSearch').removeClass('show');
        $('#newWAheader').removeClass('noShadow');
    });

    // Klick auf Lupensymbol in der Quicknavi
    $("body").on("click", ".globalSearch a.submitSearch", function(e) {
        e.preventDefault();
        var $searchForm = $(this).closest('form');
        console.log($searchForm);
        // bei der neuen META Suche soll der Suchstring als Hash Parameter angehängt werden
        if ($searchForm.data('esuchwasversion') == '2') {
            var qHash = $searchForm.find('.ttgSearchField').val();
            trackSiteSearchQN(qHash);
            window.location.href = $searchForm.attr('action') + '#q=text:"' + qHash + '"';
        } else {
            $searchForm.submit();
        }
    });

    $("body").on("keydown", '.globalSearch .ttgSearchField', function(e) {
        if (e.which == 13) {
            var $searchForm = $(this).closest('form');
            if ($searchForm.data('esuchwasversion') == '2') {
                e.preventDefault();
                var qHash = $searchForm.find('.ttgSearchField').val();
                trackSiteSearchQN(qHash);
                window.location.href = $searchForm.attr('action') + '#q=text:"' + qHash + '"';
            }
        }
    });

    //Voice Trigger in Suche
    var recognition;
    try {
        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
        recognition = new SpeechRecognition();
    } catch (e) {
        console.log(e);
    }

    // wenn nicht unterstützt oder Chrome auf iOS
    if (recognition && !(navigator.userAgent.match('CriOS') && navigator.userAgent.match(/(iPod|iPhone|iPad)/))) {
        $("body").on("click", "form.ttgSearchForm .microphone-button", function(e) {
            e.preventDefault();
            startDictation();
        });
    } else {
        $("form.ttgSearchForm .microphone-button").hide();
    }

    // quickIcons Mobile
    if ($('#quickIcons li').length > 0) {

        // wels
        if ($('#ttgRbStickyIconSidebarWrapper div').length > 0) {
            $('#quickIcons').appendTo('#ttgRbStickyIconSidebarWrapper');
        }

        var $naviHolder = $('#newWAheader .naviHolder');

        var $quickIconsMobile = $('#quickIcons').clone();
        $quickIconsMobile.insertAfter($naviHolder.find('#specialNavigation'));
        $naviHolder.find('#quickIcons').attr('id', 'quickIconsMobile');

        // globalSearch Mobile
        if ($('.globalSearch').length > 0) {
            var $globalSearchMobile = $('.globalSearch').clone();
            $globalSearchMobile.insertAfter($naviHolder.find('#quickIconsMobile'));
        }


    }

});

function trackSiteSearchQN(query) {

    // Ereignis tracken
    trackEvent('Global', 'Suchbegriff', query);

    if ($.cookie('cookieConsented-analysis') == '1') {
        var trackingSiteSearch = 'off';
        var gaActiveSiteSearch = ($.cookie("analyticsIsActive") == 'true') ? 'active' : 'disabled';
        var searchUrl = $('form.ttgSearchForm').attr('action');

        if ($('#google_analyticsJS').length) { // EventTracking mit Analytics JS [old]

            // console.log('analyticsJs');
            trackingSiteSearch = 'analyticsJS (' + gaActiveSiteSearch + ')';
            ga('send', 'pageview', searchUrl + "?q=" + query);

        } else if ($('#google_gtag').length) { // EventTracking mit GTAG [new]

            // console.log('gtag');
            trackingSiteSearch = 'gtag (' + gaActiveSiteSearch + ')';

            try {
                gtag('event', 'page_view', {
                    'page_path': searchUrl + "?q=" + query
                });
                // Übergabe view_search_results an GA4
                gtag('event', 'view_search_results', {
                    "search_term": query
                });
            } catch (e) {
                console.log('Suche: FEHLER im EventTracking: gtag() nicht gefunden. Event kann nicht an GA4 gepusht werden.');
            }

        } else {

            // Aktivieren, wenn Tracking Params in der Console nur bei deaktiviertem Google Code ausgegeben werden sollen (zB DEV System)
            // console.log('trackEvent: '+ tracking +' | '+ eventCategory +' | '+ eventAction +' | '+ eventLabel +' | '+ val +' | '+ nonI);

        }

        // Aktivieren, wenn Event Tracking Params immer in Console ausgegeben werden sollen
        console.log('trackPageView: ' + searchUrl + "?q=" + query);
    }
}

function startDictation() {
    var recognition;
    try {
        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
        recognition = new SpeechRecognition();
    } catch (e) {
        console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', e);
    }


    if (recognition) {
        $('form.ttgSearchForm .microphone-button span.fa-microphone').addClass("fa-fade");

        recognition.continuous = false;
        recognition.interimResults = true;

        recognition.lang = $('html').attr('lang');
        recognition.start();

        recognition.onresult = function(e) {
            $('input.ttgSearchField').val(e.results[0][0].transcript);
        };

        recognition.onspeechend = function() {
            recognition.stop();
            $(".globalSearch a.submitSearch").click();
        };

        recognition.onerror = function(e) {
            console.error('Speech recognition error detected: ' + e.error);
            recognition.stop();
        };

        recognition.onend = function() {
            console.log('Speech recognition service disconnected');
            $('form.ttgSearchForm .microphone-button span.fa-microphone').removeClass("fa-fade");
        };

    } else {
        alert("Your browser does not support Voice Input.");
    }
}